import { useState, useCallback, useEffect } from 'react';
import { useMountedState } from 'react-use';

import { IKnmCheckSubjectResult } from 'APIPackage/KnmModule/interfaces/IKnmCheckSubjectResult';
import { setRegistryCheck, getRegistryCheckResults } from 'APIPackage/KnmModule/services/knmRegistryApi';

export const useRegistryCheck = (knmId?: number, initialCheck?: IKnmCheckSubjectResult) => {
  const isMounted = useMountedState();
  const [isLoading, setIsLoading] = useState(false);
  const [checkSubjectResult, setCheckSubjectResult] = useState<IKnmCheckSubjectResult | undefined>(initialCheck);

  useEffect(() => {
    setCheckSubjectResult(initialCheck);
  }, [initialCheck]);

  const registryCheck = useCallback(
    async (guid?: string, inn?: string, ogrn?: string) => {
      if (!knmId || !guid || !inn || !ogrn) {
        return;
      }
      try {
        setIsLoading(true);
        const result = await setRegistryCheck(knmId, guid, inn, ogrn);

        setCheckSubjectResult(result);
      } finally {
        isMounted() && setIsLoading(false);
      }
    },
    [isMounted, knmId],
  );

  const registryCheckResults = useCallback(async () => {
    if (!knmId) {
      return;
    }
    try {
      setIsLoading(true);
      const result = await getRegistryCheckResults(knmId);

      setCheckSubjectResult(result);
    } finally {
      isMounted() && setIsLoading(false);
    }
  }, [isMounted, knmId]);

  return {
    isLoading,
    checkSubjectResult,
    registryCheck,
    registryCheckResults,
  };
};
